<template>
  <el-dialog
    title="资源获取记录"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    :append-to-body="true"
    @close="closeEvent"
    @closed="closedEvent"
  >
    <div>
      <!-- <el-button
        type="primary"
        class="button_box"
        icon="el-icon-link"
        size="mini"
        @click="getboox"
        >绑定授权码</el-button
      > -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="资源名称">
          <template slot-scope="scope">
            <div style="display: table; width: 100%; position: relative">
              <el-image
                style="
                  width: 90px;
                  height: 90px;
                  box-shadow: 0 0 3px #ccc;
                  float: left;
                  margin-right: 10px;
                "
                :src="scope.row.cover"
                fit="contain"
              ></el-image>
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.relevanceName"
                placement="top"
              >
                <span
                  class="ellipsis-twoRow"
                  style="
                    display: inline-box;
                    display: -webkit-inline-box;
                    float: left;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                  "
                  >{{ scope.row.relevanceName }}</span
                >
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="180">
          <template slot-scope="scope">
            {{
              scope.row.resourceType === "bundle"
                ? "资源包"
                : scope.row.resourceType === "goods"
                ? "商品"
                : "专题"
            }}
          </template>
        </el-table-column>
        <el-table-column label="获取途径" width="180">
          <template slot-scope="scope">
            {{ callDictionaries(acquireSourcelist, scope.row.acquireSource) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="获取日期" width="180">
        </el-table-column>
      </el-table>
    </div>
    <div style="width: 100%; overflow: hidden">
      <div style="float: right; margin-top: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listquery.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="listquery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <GetdialogVisible
      :list="GetdialogVisible"
      @getShow="getShow"
    ></GetdialogVisible>
  </el-dialog>
</template>
<script>
import { selectMyResourceListGoodsNoBuy } from "@/api/user/myResources.js";
import {
  teachingAttrList, //字典值
} from "@/api/bookstore/bookstore";
export default {
  components: {
    GetdialogVisible: () => import("./GetdialogVisible.vue"),
  },
  data() {
    return {
      binding: "",
      dialogVisible: false,
      GetdialogVisible: false,
      tableData: [],
      listquery: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      acquireSourcelist: [], //获取途径字典
    };
  },
  methods: {
    getShow() {
      this.GetdialogVisible = false;
      this.dialogVisible = false;
      this.$emit("Action", true);
    },
    getboox() {
      this.GetdialogVisible = true;
    },
    openDialog(type, data) {
      this.dialogVisible = true;
      this.getList();
      this.getresource_source();
    },
    closeEvent() {
      this.formList = {};
    },
    getresource_source() {
      //来源
      teachingAttrList("resource_source").then((res) => {
        this.acquireSourcelist = res.data;
      });
    },
    closedEvent() {},
    getList() {
      selectMyResourceListGoodsNoBuy(this.listquery).then((res) => {
        this.tableData = res.rows;
        this.total = res.total;
      });
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    //每页条数
    handleSizeChange(val) {
      this.listquery.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.listquery.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.button_box {
  position: absolute;
  top: 18px;
  left: 150px;
}
</style>